module.exports = __webpack_public_path__ + "img/up_csv_btn.828ce1b3.svg";